import React from "react";
import { SelectedSubmissionsBuilderField } from "../../reducer";
import { SubmissionsBuilderFieldSettings } from "../../types";
import DropdownWidgetSettings from "./DropdownWidgetSettings";

const MultiSelectWidgetSettings = (
  props: SelectedSubmissionsBuilderField & SubmissionsBuilderFieldSettings,
) => {
  return <DropdownWidgetSettings {...props} />;
};

MultiSelectWidgetSettings.displayName = "MultiSelectWidgetSettings";

export default MultiSelectWidgetSettings;
